<template>
	<div>
		<CRow class="typo-body-2">
			<CCol md="6">
				<CInput
					v-model.trim="$v.description.shortDescriptionEN.$model"
					type="text"
					:is-valid="!$v.description.shortDescriptionEN.$error && null"
					:invalid-feedback="$t('global.error.required')"
					placeholder="Type Short description (EN)"
					label="Short description (EN)*"
				/>
			</CCol>
			<CCol md="6">
				<CInput
					v-model.trim="$v.description.shortDescriptionTH.$model"
					type="text"
					:is-valid="!$v.description.shortDescriptionTH.$error && null"
					:invalid-feedback="$t('global.error.required')"
					placeholder="Type Short description (TH)"
					label="Short description (TH)*"
				/>
			</CCol>
		</CRow>
		<CRow class="typo-body-2">
			<CCol md="12">
				<label>Description (EN)*</label>
				<BaseRichTextEditor
					v-model="$v.description.descriptionEN.$model"
					:is-valid="!$v.description.descriptionEN.$error"
					:invalid-feedback="$t('global.error.required')"
					data-test-id="description-en"
					name="descriptionEN"
				/>
			</CCol>
		</CRow>
		<CRow class="typo-body-2 my-3">
			<CCol md="12">
				<label>Description (TH)*</label>
				<BaseRichTextEditor
					v-model="$v.description.descriptionTH.$model"
					:is-valid="!$v.description.descriptionTH.$error"
					:invalid-feedback="$t('global.error.required')"
					data-test-id="description-th"
					name="descriptionTH"
				/>
			</CCol>
		</CRow>
	</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
	name: 'PromotionDiscountDescriptionDappForm',

	props: {
		description: {
			type: Object,
			default: () => {},
		},
	},

	validations() {
		return {
			description: {
				shortDescriptionEN: {
					required,
				},
				shortDescriptionTH: {
					required,
				},
				descriptionEN: {
					required,
				},
				descriptionTH: {
					required,
				},
			},
		};
	},
};
</script>
